export const storageAgeOption = [
  // {id: 'DAY_0', text: '0天以上库龄'},
  {id: 'DAY_30', text: '30天以上库龄'},
  {id: 'DAY_60', text: '60天以上库龄'},
  {id: 'DAY_90', text: '90天以上库龄'},
  {id: 'DAY_180', text: '180天以上库龄'},
  {id: 'DAY_270', text: '270天以上库龄'},
  {id: 'DAY_365', text: '365天以上库龄'},
];
export const turnoverOption = [
  {id: 'DAY_0', text: '大于0天'},
  {id: 'DAY_30', text: '大于30天'},
  {id: 'DAY_45', text: '大于45天'},
  {id: 'DAY_60', text: '大于60天'},
  {id: 'DAY_90', text: '大于90天'},
  {id: 'DAY_180', text: '大于180天'},
];
export const rankOrderOption = [
  {id: 'TURNOVER', text: '按可售周转排序'},
  {id: 'UNSALABLE', text: '按FBA滞销量排序'}
];

export const dashboardPayOption = [
   {id: 'YES', text: '包含未付款订单'},
   {id: 'NO', text: '不包含未付款订单'}
];